import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-white mb-3">{title}</h2>
    {children}
  </section>
);

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-navy-950 font-body text-gray-100">
      <div className="max-w-3xl mx-auto px-6 py-24 sm:py-32">
        <Link
          to="/"
          data-testid="datenschutz-back-link"
          className="inline-flex items-center gap-2 text-sm text-blau-glow hover:text-white transition-colors"
        >
          <ArrowLeft size={16} aria-hidden="true" />
          Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white mt-10">
          Datenschutzhinweise
        </h1>

        <div className="mt-10 space-y-10 text-sm sm:text-base text-gray-400 leading-relaxed">
          <Section title="1. Verantwortlicher">
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="mt-3">
              Jörg Eisbach
              <br />
              BlaulichtPraxis
              <br />
              Brückenstraße 40
              <br />
              56112 Lahnstein
              <br />
              E-Mail:{" "}
              <a
                href="mailto:kontakt@blaulichtpraxis.de"
                data-testid="datenschutz-mail-link"
                className="text-blau-glow underline underline-offset-4 hover:text-white"
              >
                kontakt@blaulichtpraxis.de
              </a>
            </p>
          </Section>

          <Section title="2. Verarbeitung bei Bestellanfragen">
            <p>
              Wenn Sie uns über das Bestellformular eine Anfrage oder
              Bestellung senden, verarbeiten wir die von Ihnen angegebenen
              Daten (Name, Organisation, Funktion, E-Mail-Adresse,
              Telefonnummer, Anzahl der Exemplare, Rechnungs- und ggf.
              Lieferadresse sowie Ihre Anmerkungen) ausschließlich zur
              Bearbeitung und Abwicklung Ihrer Bestellung. Rechtsgrundlage
              ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung und
              Vertragserfüllung).
            </p>
            <p className="mt-3">
              Ihre Angaben werden uns per E-Mail übermittelt und zur
              Abwicklung gespeichert. Wir löschen die Daten, sobald sie für
              die Bearbeitung nicht mehr erforderlich sind und keine
              gesetzlichen Aufbewahrungspflichten entgegenstehen. Eine
              Weitergabe an Dritte erfolgt nicht, es sei denn, dies ist zur
              Vertragserfüllung (z. B. Versand) erforderlich.
            </p>
          </Section>

          <Section title="3. E-Mail-Versand">
            <p>
              Für den technischen Versand der Bestell-E-Mails nutzen wir
              einen E-Mail-Dienstleister, mit dem eine
              Auftragsverarbeitung vereinbart ist. Die Verarbeitung erfolgt
              auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </Section>

          <Section title="4. Hosting und Server-Logdateien">
            <p>
              Beim Aufruf dieser Website verarbeitet der Hostinganbieter
              automatisch technische Zugriffsdaten (z. B. IP-Adresse,
              Datum und Uhrzeit des Zugriffs, aufgerufene Seite,
              Browsertyp). Diese Daten sind technisch erforderlich, um die
              Website auszuliefern und deren Sicherheit zu gewährleisten.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an einem sicheren und stabilen Betrieb).
            </p>
          </Section>

          <Section title="5. Externe Schriftarten (Google Fonts)">
            <p>
              Diese Website nutzt Schriftarten von Google Fonts. Beim
              Aufruf der Seite wird eine Verbindung zu Servern von Google
              hergestellt, wobei Ihre IP-Adresse übertragen wird.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an einer einheitlichen und ansprechenden
              Darstellung).
            </p>
          </Section>

          <Section title="6. Reichweitenanalyse">
            <p>
              Diese Website nutzt einen Analysedienst der
              Bereitstellungsplattform (PostHog, bereitgestellt über
              Emergent, Serverstandort EU), um die Nutzung der Website
              statistisch auszuwerten und das Angebot zu verbessern.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an der Optimierung des Angebots).
            </p>
          </Section>

          <Section title="7. Ihre Rechte">
            <p>
              Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie
              betreffenden personenbezogenen Daten:
            </p>
            <ul className="mt-3 list-disc pl-5 space-y-1.5">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Zur Ausübung Ihrer Rechte genügt eine E-Mail an{" "}
              <a
                href="mailto:kontakt@blaulichtpraxis.de"
                className="text-blau-glow underline underline-offset-4 hover:text-white"
              >
                kontakt@blaulichtpraxis.de
              </a>
              .
            </p>
          </Section>

          <Section title="8. Beschwerderecht">
            <p>
              Sie haben das Recht, sich bei einer
              Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
              personenbezogenen Daten durch uns zu beschweren. Zuständig
              ist die Aufsichtsbehörde des Bundeslandes, in dem der
              Verantwortliche seinen Sitz hat.
            </p>
          </Section>

          <Section title="9. SSL- bzw. TLS-Verschlüsselung">
            <p>
              Diese Website nutzt aus Sicherheitsgründen und zum Schutz der
              Übertragung vertraulicher Inhalte eine SSL- bzw.
              TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
              Sie an „https://" in der Adresszeile Ihres Browsers.
            </p>
          </Section>

          <p className="text-xs text-gray-600">Stand: August 2026</p>
        </div>
      </div>
    </div>
  );
}
